import { inject, provide, ref, type Ref } from 'vue'

export interface FeedbackContext {
  uuid?: string
  title?: string
  subject?: string
}

const FeedbackContextKey = Symbol('FeedbackContext')

export function provideFeedbackContext(initialContext: FeedbackContext = {}) {
  const context: Ref<FeedbackContext> = ref(initialContext)
  
  const updateContext = (updates: Partial<FeedbackContext>) => {
    context.value = { ...context.value, ...updates }
  }
  
  provide(FeedbackContextKey, {
    context,
    updateContext
  })
  
  return { context, updateContext }
}

export function useUserFeedbackContext() {
  const injected = inject<{
    context: Ref<FeedbackContext>
    updateContext: (updates: Partial<FeedbackContext>) => void
  }>(FeedbackContextKey, {
    context: ref({}),
    updateContext: () => {}
  })
  
  return injected
}
